export const CAMPAIGN_REPORT_PDF_SNAPSHOT_VERSION = 1;

/**
 * Deep-clones into plain JSON: Dates become timestamps, functions/undefined
 * are dropped. Same rules as the global report snapshot.
 */
const toJsonSafe = (value) => {
  if (value === undefined || value === null) {
    return value ?? null;
  }

  return JSON.parse(
    JSON.stringify(value, function replacer(key, currentValue) {
      const rawValue = this[key];
      if (rawValue instanceof Date) {
        return rawValue.getTime();
      }
      return currentValue;
    })
  );
};

const toTimestamp = (value) => {
  if (value === null || value === undefined) {
    return null;
  }
  if (value instanceof Date) {
    return value.getTime();
  }
  return value;
};

const toDateRange = (dateRange) => ({
  startDateTime: toTimestamp(dateRange?.startDateTime),
  endDateTime: toTimestamp(dateRange?.endDateTime),
});

/**
 * JSON snapshot for the server-side campaign report. Stores the raw inputs the
 * page already has. Aggregation and currency helpers are functions and are
 * rebuilt on the render page from campaign + currenciesConfiguration.
 */
export const buildCampaignReportPdfSnapshot = ({
  campaignID,
  campaign,
  currenciesConfiguration,
  reportConfiguration,
  reportDateLimits,
  dateRange,
  breakdown,
  filteredLogs,
  userNames,
  summaryText,
  learnings,
  isEmptyReport,
  language,
}) =>
  toJsonSafe({
    version: CAMPAIGN_REPORT_PDF_SNAPSHOT_VERSION,
    language: language || null,
    campaignID: campaignID || null,
    campaign: campaign || {},
    currenciesConfiguration: currenciesConfiguration || {},
    reportConfiguration: toDateRange(reportConfiguration),
    reportDateLimits: {
      minStartDate: toTimestamp(reportDateLimits?.minStartDate),
      maxStartDate: toTimestamp(reportDateLimits?.maxStartDate),
      maxEndDate: toTimestamp(reportDateLimits?.maxEndDate),
    },
    dateRange: toDateRange(dateRange),
    breakdown: breakdown || "weekly",
    filteredLogs: Array.isArray(filteredLogs) ? filteredLogs : [],
    userNames: userNames || {},
    summaryText: summaryText || "",
    learnings: Array.isArray(learnings) ? learnings : [],
    isEmptyReport: Boolean(isEmptyReport),
  });

export default buildCampaignReportPdfSnapshot;
